module.exports = __webpack_public_path__ + "static/fg-ceef4879ff1757048096e6a8462b947e.png";